import { initializeModal } from './initializeModal';
import { openModal } from './openModal';
import { closeModal } from './closeModal';
import { manageEventListeners } from './manageEventListeners';
import { backfaceFixed } from './backfaceFixed';
import { waitModalAnimation } from './waitModalAnimation';

export const modal = {
  initializeModal,
  openModal,
  closeModal,
  manageEventListeners,
  backfaceFixed,
  waitModalAnimation
};
